import { render } from "./AcPoints.vue?vue&type=template&id=17c501eb&scoped=true&ts=true"
import script from "./AcPoints.vue?vue&type=script&lang=ts"
export * from "./AcPoints.vue?vue&type=script&lang=ts"

import "./AcPoints.vue?vue&type=style&index=0&id=17c501eb&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/5c6defa0/0/anyclass/anyclass-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17c501eb"]])

export default __exports__